import { InputEnumOption, Translations, cbaCodes } from "@salaxy/core";
import { InputController } from "./InputController";

/**
 * Controller behind form controls that selects Collective Bargain Agreement code.
 */
export class InputCollectiveBargainAgreementController extends InputController {

  /**
   * List of collective bargain agreement codes to exclude from the selection list.
   */
  public hiddenCodes: number[];

  private cbaCodes: InputEnumOption[] = [];

  public static $inject = [];

  /**
   * Creates a new InputCollectiveBargainAgreementController
   * @ignore
   */
  constructor() {
    super();
  }

  /** Sets the default values in init. */
  public $onInit() {
    super.$onInit();
    const currentLanguage = Translations.getLanguage();
    this.cbaCodes = cbaCodes.map((x: any) => {
      const text = currentLanguage === "fi" ? x.labelFi : currentLanguage === "en" ? x.labelEn : x.labelSv;
      return { value: x.code, text } as InputEnumOption;
    });
  }

  /**
   * Returns filtered list of collective bargain agreement codes based on search string.
   * @param searchString - String to filter codes by
   * @returns Filtered list of collective bargain agreement codes as InputEnumOptions
   */
  public getCbaCodes = (searchString: string): InputEnumOption[] => {
    if (!searchString || searchString.length < 2) {
      return this.cbaCodes.filter( (x) => !this.hiddenCodes?.find( (c) => c.toString() === x.value.toString()) );
    }
    let result = this.cbaCodes.filter((x) => x.text.toLowerCase().indexOf(searchString.toLowerCase()) >= 0);
    if (this.hiddenCodes) {
      result = result.filter( (x) => !this.hiddenCodes.find( (c) => c.toString() === x.value.toString()) );
    }
    return result;
  };

  /**
   * Returns the label for given collective bargain agreement code.
   * @param value - Value of the collective bargain agreement code.
   */
  public getCbaLabel = (value: string): string => {
    return this.cbaCodes.find(x => x.value === value)?.text;
  };

  /** Returns the placeholder text - this control has a default text. */
  public getPlaceholder() {
    return super.getPlaceholder() || Translations.get("SALAXY.NG1.InputCollectiveBargainAgreement.getPlaceholder");
  }

  /**
   * Returns the HTML for the tooltip.
   * @returns HTML for the tooltip
   */
  public getToolTipHtml() {
    return `<span>${Translations.get("SALAXY.NG1.WorkerWizardComponent.employment.info.cbaCodeInfo")}</span>`;
  }
}
